import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate, useLocation, Navigate } from "react-router-dom";
import { fancyTimeFormat } from "../../Common/Function";
import {
  GetSeo,
  ResendVerifyCode,
  VerifyCode,
  ForgetPass,
} from "./Components/Services";
import { useDispatch, useSelector } from "react-redux";

const VeryfyCode = ({ isModal, mobileData, setShowModalLogin, setShowVerify, setShowLogin }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const initialState = {
    loading: false,
    data: {
      mobile: !isModal ? location.state ? location.state.mobile : null : mobileData,
      password: null,
      codeverify: null,
    },
  };

  const [state, setState] = useState(initialState);
  const { basket, kind, mobile, user_type } = useSelector(state => state);

  // useEffect(() => {
  //   getVeryfyCode(mobile);
  // }, []);

  // const getVeryfyCode = mobile => {
  //   ForgetPass(mobile).then();
  // };

  const [timecode, setTimecode] = useState(120);
  const dispatch = useDispatch();

  const CodeHandler = (mobile, codeverify) => {
    if (state.data.codeverify !== null) {
      setState({ ...state, loading: true });
      VerifyCode(mobile, codeverify).then(result => {
        setState({ ...state, loading: false });
        if (result) {
          dispatch({
            local_storage: {
              key: "user",
            },
            payload: "user",
            type: "REMOVE",
          });
          dispatch({
            local_storage: {
              key: "user",
              value: result,
            },
            payload: { user: result },
            type: "SET",
          });
          dispatch({
            local_storage: {
              key: "user_type",
              value: result.role,
            },
            payload: { user_type: result.role },
            type: "SET",
          });

          if (!isModal) {
            navigate("/User/Dashboard");
          }
          else {
            setShowModalLogin(false)
          }

        }
      });
    }
  };

  const ResendCodeHandler = mobile => {
    setState({ ...state, loading: true });
    ResendVerifyCode(mobile).then(result => {
      setState({
        loading: false,
        data: { ...state.data, result: result },
      });
    });
  };

  const SetTimeOut = () => {
    setTimeout(() => {
      if (timecode >= 1) {
        setTimecode(timecode - 1);
      }
    }, 1000);
  };
  SetTimeOut();

  const CheckResend = () => {
    if (timecode === 0) {
      ResendCodeHandler(state.data.mobile);
      setTimecode(120);
      SetTimeOut();
    }
  };

  if (user_type) {
    return <Navigate to={"/User/Dashboard"} />
  }

  return (
    <React.Fragment>
      {!isModal &&
        <Helmet>
          <title>نیکوتن | ورود به سایت</title>
        </Helmet>
      }
      <div className={"main-login d-flex justify-content-center align-items-center " + (!isModal && "py-4 ")
        + (window.screen.width > 575 ? !isModal && "my-5" : "my-0")}>
        <div className="container-fluid px-3 px-md-5">
          <div className="row justify-content-center">
            <div
              className={"rounded-11 login " + (!isModal && "part-padding")}
              style={{
                boxShadow: !isModal && "rgba(0, 0, 0, 0.12) 0px 0px 3px, rgba(0, 0, 0, 0.24) 0px 0px 5px",
                width: !isModal && "450px"
              }}>
              <div className="center">
                <div className="top mb-5 d-flex flex-column align-items-center justify-content-center">
                  <Link to={"/"}>
                    <img
                      className="img"
                      style={{ width: window.screen.width > 575 ? "150px" : "100px" }}
                      src={window.origin + "/WebSide/assets/images/logo.png"}
                      alt="nikotan | نیکوتن"
                    />
                  </Link>
                  <img
                    style={{ width: window.screen.width > 575 ? "100%" : "80%" }}
                    className="mt-1"
                    src={window.origin + "/WebSide/assets/images/sam.png"}
                  />
                </div>
                <div className="form-group login-form-group mb-3 mx-auto">
                  <p className="mb-2" style={{ color: "#404040" }}>
                    به شماره موبایل
                    <span className="text-danger" style={{ margin: "0 5px", color: "#E42A3F" }}>
                      {mobile}
                    </span>
                    کد تایید ارسال شد
                  </p>
                  <div className="inputt-group d-flex">
                    <input
                      className="form-control"
                      type="text"
                      onChange={e =>
                        setState({
                          ...state,
                          data: { ...state.data, codeverify: e.target.value },
                        })
                      }
                      placeholder="کد تایید"
                      onKeyDown={e => {
                        if (e.key == "Enter") {
                          CodeHandler(mobile, state.data.codeverify);
                        }
                      }}
                      style={{ borderRadius: "10px" }}
                    />
                  </div>
                </div>
                <button
                  onClick={() => CodeHandler(mobile, state.data.codeverify)}
                  className={`btn btn-red-v2 w-100 h6 mb-3 text-white ${state.loading ? "disabled" : null} `}
                  style={{ borderRadius: "10px" }}
                >
                  {state.loading ? "درحال پردازش" : "بررسی کد تایید"}
                </button>
                <button
                  type="button"
                  className="pure-input d-block mx-auto my-3"
                  onClick={e => {
                    CheckResend();
                  }}
                  style={{ color: "#404040" }}
                >
                  {" "}
                  {timecode === 0
                    ? "کد تایید را دریافت نکردید ؟ کلیک کنید"
                    : `مهلت وارد کردن کد تایید:  ${fancyTimeFormat(timecode)}`}
                </button>
                {/* <p className="text-center" style={{ color: "#404040" }}>
                  پیش از این ثبت نام کرده اید؟
                  {!isModal
                    ?
                    <Link
                      to={"/UserLogin"}
                      className=" ms-2 fw-bold"
                      style={{ color: "#E42A3F" }}>
                      صفحه ورود
                    </Link>
                    :
                    <Link
                      onClick={() => {
                        setShowVerify({ status: false })
                        setShowLogin(true)
                      }}
                      className=" ms-2 fw-bold"
                      style={{ color: "#E42A3F" }}>
                      صفحه ورود
                    </Link>
                  }

                </p> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default VeryfyCode;
